import { Primitive } from 'zod'

export function unique<T extends Primitive>(items: Iterable<T>): T[] {
  const uniqueItems = [] as T[]
  for (const item of items) {
    if (!uniqueItems.includes(item)) {
      uniqueItems.push(item)
    }
  }
  return uniqueItems
}

export function uniqueByProperty<T>(
  property: keyof T
): (value: T, index: number, self: T[]) => boolean {
  return (value, index, self) =>
    self.findIndex((item) => item[property] === value[property]) === index
}
